import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';
import miniToastr from 'mini-toastr'

export const functions_hotel_data = {

    data: function () {
        return {
            service:null,
            services :[],
            disease:null,
            diseases:[],
            disease_category:null,
            disease_categories:[],
        };
    },
    computed: {
    },

    methods: {
        /*
         *   Список заболеваний
         */

        loadDiseases: function (onSuccess=null, param=null) {
            if (!this.isDiseasesLoaded()) {
                this.httpPrepare();
                this.$http.get(this.apiurl('disease')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.diseases = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetDiseases: function () {
            this.diseases = [];
            return this;
        },

        isDiseasesLoaded: function () {
            return this.is(this.diseases) && this.diseases.length;
        },

        /*
         *   Заболевание
         */

        loadDisease: function (disease_id, onSuccess=null, param=null) {
            if (!this.isDiseaseLoaded() && disease_id) {
                this.disease = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('disease/' + disease_id )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.disease = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        isDiseaseLoaded: function () {
            return this.is(this.disease);
        },

        createDisease: function (onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('disease/create')).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Заболевание добавлено', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },

        deleteDisease: function (disease_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('disease/' + disease_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Заболевание удалено', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },

        saveDisease: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('disease/'+this.disease.id+'/save'), this.disease).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                miniToastr["info"]('Заболевание сохранено', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },

        /*
         *   Список групп заболеваний
         */

        loadDiseaseCategories: function (onSuccess=null, param=null) {
            if (!this.isDiseaseCategoriesLoaded()) {
                this.httpPrepare();
                this.$http.get(this.apiurl('disease/cat')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.disease_categories = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetDiseaseCategories: function () {
            this.disease_categories = [];
            return this;
        },

        isDiseaseCategoriesLoaded: function () {
            return this.is(this.disease_categories) && this.disease_categories.length;
        },

        /*
         *   Группа заболеваний
         */

        loadDiseaseCategory: function (disease_category_id, onSuccess=null, param=null) {
            if (!this.isDiseaseCategoryLoaded() && disease_category_id) {
                this.disease_category = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('disease/cat/' + disease_category_id )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.disease_category = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        isDiseaseCategoryLoaded: function () {
            return this.is(this.disease_category);
        },

        createDiseaseCategory: function (onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('disease/cat/create')).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Группа заболеваний добавлена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },

        deleteDiseaseCategory: function (disease_category_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('disease/cat/' + disease_category_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Группа заболеваний удалена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },

        saveDiseaseCategory: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('disease/cat/'+this.disease_category.id+'/save'), this.disease_category).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                miniToastr["info"]('Группа заболеваний "'+this.disease_category.title+'"сохранена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },

        /*
         *   Список услуг
         */

        loadServices: function (onSuccess=null, param=null) {
            if (!this.isServicesLoaded()) {
                this.httpPrepare();
                this.$http.get(this.apiurl('service')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.services = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetServices: function () {
            this.services = [];
            return this;
        },

        isServicesLoaded: function () {
            return this.is(this.services) && this.services.length;
        },

        /*
         *   Услуга
         */

        loadService: function (service_id, onSuccess=null, param=null) {
            if (!this.isServiceLoaded() && service_id) {
                this.service = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('service/' + service_id )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.service = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        isServiceLoaded: function () {
            return this.is(this.service);
        },

        createService: function (onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('service/create')).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Опция добавлена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },

        deleteService: function (service_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('service/' + service_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Опция удалена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },

        saveService: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('service/'+this.service.id+'/save'), this.service).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                miniToastr["info"]('Опция сохранена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError)
        },


    }

};

